import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { RoleListNameCell } from './role-list-name.cell';
import { RoleListNameHeader } from './role-list-name.header';

export const RoleListNameColumn: IdentifiedColumnDef<
  GatewayRoleModel,
  GatewayRoleModel['name']
> = {
  enableSorting: true,
  header: RoleListNameHeader,
  cell: RoleListNameCell,
};
